module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "cont",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "h2f1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf0",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Foreword"
    }
  }, [_c('b', [_vm._v("FOREWORD BY JOHN BIRDSALL")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Introduction"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001"
    }
  }, [_vm._v("CHAPTER 1: SEAFOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec1#asec1"
    }
  }, [_vm._v("TEACH A GIRL TO FISH")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec1-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec1#asec1-1"
    }
  }, [_vm._v("CRISTINA QUACKENBUSH")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Originally from the slums of Manila, Cristina grows up in the US Midwest and explores what kinilaw, a dish she originally found repulsive, means to her.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec1-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec12#asec1-2"
    }
  }, [_c('b', [_vm._v("Kinilaw:")]), _vm._v(" "), _c('i', [_vm._v("Vinegar and Citrus–Cured Fish with Coconut Milk and Green Mango")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec2#asec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GOOD FOR ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec2-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec2#asec2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JACQUELINE CHIO-LAURI")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("A restaurant manager in her mid-20s, Jacqueline grapples with singlehood in a couple-oriented society and a restaurant with a signature dish for two.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec24#asec2-4"
    }
  }, [_c('b', [_vm._v("Seafood Sinigang:")]), _vm._v(" "), _c('i', [_vm._v("Sour and Savory Seafood Soup Seasoned with Gremolata")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec3#asec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SMOKE GETS IN MY EYES")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec3-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec3#asec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROWENA DUMLAO-GIARDINA")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Rowena is hooked. Years later, she discovers the reason behind her")]), _vm._v(" Fatal Attraction–"), _c('i', [_vm._v("like obsession for a particular type of plant.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec3-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec36#asec3-6"
    }
  }, [_c('b', [_vm._v("Inihaw na Isda at Ensaladang Talong:")]), _vm._v(" "), _c('i', [_vm._v("Stuffed Fish Grilled in Banana Leaves and Eggplant Salad with Toasted Pancetta")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec4#asec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE HEAT IS ON")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec4-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec4#asec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISSY CAMBA")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("How can Chrissy’s grandmother spare her from the pain of her parents’ early divorce and the disappointment from getting “chopped” at a reality cooking competition?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec4-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec48#asec4-8"
    }
  }, [_c('b', [_vm._v("Crab Torta:")]), _vm._v(" "), _c('i', [_vm._v("Crab Omelet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec5#asec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANG PAMBIHIRANG LUTO NI NANAY (MOM’S EXTRAORDINARY COOKING)")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec5-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter001sec5#asec5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CRISTETA “CRIS” COMERFORD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Cris, the White House executive chef, compares her mother to a fictional character who seems perfect in every way—except for one serious condition unknown to all.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec5-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter001sec510#asec5-10"
    }
  }, [_c('b', [_vm._v("Escabeche-Inspired Fried Snapper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 2: POULTRY")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec6#asec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EIGHT WAYS TO COOK LIKE MA")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec6-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec6#asec6-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JANICE LOBO SAPIGAO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Janice narrates eight personal experiences, including an incident at Costco and the impact of the huge retailer on the lives of immigrant and working-class families.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec6-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter002sec612#asec6-12"
    }
  }, [_c('b', [_vm._v("Tinola:")]), _vm._v(" "), _c('i', [_vm._v("Ginger Chicken Soup with Moringa")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec7#asec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN THE GREAT WHITE NORTH")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec7-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec7#asec7-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALLAN PINEDA")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("How does Allan, a second-generation immigrant, figure out why he is placed in an ESL (English as a second language) class when English is his first language?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec7-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter002sec714#asec7-14"
    }
  }, [_c('b', [_vm._v("Sous Vide Fried Chicken Breasts")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec8#asec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TO MAKE A HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec8-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec8#asec8-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MELISSA R. SIPIN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Abandoned by her biological mother at a very young age, Melissa is raised by her grandmother, who teaches her everything—except how to cook.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec8-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter002sec816#asec8-16"
    }
  }, [_c('b', [_vm._v("Baked Chicken Adobo Infused with Coconut Milk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec9#asec9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY AFRITADA ANGEL")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec9-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter002sec9#asec9-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DALENA HASKINS BENAVENTE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("US-born, half American–half Filipino Dalena visits the Philippines for the first time and encounters")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("the healing powers of a mystical woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec9-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter002asec918#asec9-18"
    }
  }, [_c('b', [_vm._v("Spaghetti Sauce Chicken Afritada")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 3: MEAT")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec10#asec10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MAKING OF LUMPIA")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec10-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec10#asec10-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ALEXA ALFARO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("How can Alexa drop a bomb without breaking her father’s heart? Alexa tries the same tactic her father used decades ago to win her mother’s heart.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec10-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter003sec1020#asec10-20"
    }
  }, [_c('b', [_vm._v("Lumpia:")]), _vm._v(" "), _c('i', [_vm._v("Pork and Vegetable Egg Rolls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec11"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec11#asec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("POUNDING ON THE DOOR WITH A SLEDGEHAMMER")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec11-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec11#asec11-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ROBERT MENOR")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("When Robert isn’t jazz club–hopping or getting kicked out of places only a hipster can love, he pounds on doors with a sledgehammer of pulled pork adobo.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec11-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter003sec1122#asec11-22"
    }
  }, [_c('b', [_vm._v("Pulled Pork Adobo Loko Sliders")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocaaa",
    attrs: {
      "id": "sec11-22a"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/Chapter003sec1122b#asec11-22a"
    }
  }, [_c('b', [_vm._v("Atchara")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec12#asec12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE MIGHTY CLUB OF MIGHTOR")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec12-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec12#asec12-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHRISTIAN ANDRE PETTERSEN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Many things aren’t going in the right direction at a culinary competition where Chef Christian battles to perfect a pork dish inspired by crispy pata.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec12-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter003sec1224#asec12-24"
    }
  }, [_c('b', [_vm._v("Crispy Pata:")]), _vm._v(" "), _c('i', [_vm._v("Braised Boneless Pork Hocks with Crispy Pork Rind, Ginger-Soy Glaze, and Turnip-Apple Slaw")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec13#asec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IN LOVE AND REVOLUTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec13-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter003sec13#asec13-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VANESSA DEZA HANGAD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Politics finds its way into Vanessa’s family life as she tries to process her parents’ separation through the lens of the People Power Revolution and a reconciliatory dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec13-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter003sec1326#asec13-26"
    }
  }, [_c('b', [_vm._v("Kare-Kare:")]), _vm._v(" "), _c('i', [_vm._v("Oxtail Stew in Thick Peanut Sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 4: VEGETABLES")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec14#asec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("AMPALAYA EPIPHANY")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec14-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec14#asec14-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LISA SUGUITAN MELNICK")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("An epiphany presents itself to Lisa at the age of 55 during her first journey to the Philippines. Her discovery goes beyond ampalaya.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec14-28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter004sec1428#asec14-28"
    }
  }, [_c('b', [_vm._v("Tortang Ampalaya:")]), _vm._v(" "), _c('i', [_vm._v("Stir-Fried Bitter Melon Omelet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec15#asec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACROSS THE MILES")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec15-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec15#asec15-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VANESSA LORENZO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Separated from her family for the first time, Vanessa recalls an heirloom dish that has traveled across the miles and stood the test of time.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec15-30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter004sec1530#asec15-30"
    }
  }, [_c('b', [_vm._v("Habichuelas:")]), _vm._v(" "), _c('i', [_vm._v("Navy Beans with Chorizo and Tomato Chutney")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec16#asec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("YOU CAN’T RUSH A GOOD THING")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec16-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec16#asec16-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("JOANNE BOSTON-KWANHULL")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Joanne is never on time. She is the last one to arrive at school, and the last one to be picked up. When is it worth it to wait and when is it not?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec16-32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter004sec1632#asec16-32"
    }
  }, [_c('b', [_vm._v("Monggo (Balatong):")]), _vm._v(" "), _c('i', [_vm._v("Stewed Mung Beans with Pork Belly Sofrito")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec17#asec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRIVING HOME")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec17-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec17#asec17-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LEONARDO ESPERACION FERNANDEZ JR.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_vm._v("MasterChef "), _c('i', [_vm._v("runner-up Leo Fernandez journals his grueling day in the kitchen as he navigates his way home in a city he hardly knows.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec17-34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter004sec1734#asec17-34"
    }
  }, [_c('b', [_vm._v("Pinakbet at Bagnet:")]), _vm._v(" "), _c('i', [_vm._v("Mixed Vegetables with Bagoong Sauce and Crispy Pork Belly")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec18#asec18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("COOKING BY HINDSIGHT")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec18-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter004sec18#asec18-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FRANCIS C. MACANSANTOS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("A culinarily challenged professor strums rambunctious renderings of the Beatles for food until a former")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("cook for the rebel army comes into his life.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec18-36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter004sec1836#asec18-36"
    }
  }, [_c('b', [_vm._v("Dinendeng:")]), _vm._v(" "), _c('i', [_vm._v("Mixed Vegetable and Shrimp Stew with Red Wine")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 5: NOODLES")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec19#asec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE PRICE OF FREEDOM")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec19-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec19#asec19-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MONICA MACANSANTOS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Monica’s father wants to murder someone when he sees a skeletal version of his only child walking toward him.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec19-38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter005sec1938#asec19-38"
    }
  }, [_c('b', [_vm._v("Pansit Bihon Guisado:")]), _vm._v(" "), _c('i', [_vm._v("Stir-Fried Rice Noodles with Shrimp and Adobo")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec20#asec20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EVERY SUNSET")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec20-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec20#asec20-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NASTASHA ALLI")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Nastasha has zero dollars to her name and no cooking skills when she immigrates to Canada. How can she make a home?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec20-40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter005sec2040#asec20-40"
    }
  }, [_c('b', [_vm._v("Pansit Palabok:")]), _vm._v(" "), _c('i', [_vm._v("Rice Noodles with Seafood and Thick Shrimp Sauce")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec21"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec21#asec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PLAIN BOWL OF NOODLES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec21-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter005sec21#asec21-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PAOLO ESPANOLA")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Saudi-raised New Yorker Paolo Espanola, a believer that food can be used to solve most of the world’s problems, muses over a bowl of noodle soup.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec21-42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter005sec2142#asec21-42"
    }
  }, [_c('b', [_vm._v("Pansit Molo:")]), _vm._v(" "), _c('i', [_vm._v("Meat and Shrimp Dumpling Soup with Shiitake Mushrooms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 6: RICE")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec22#asec22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CAN’T HAVE ONE WITHOUT THE OTHER")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec22-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec22#asec22-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MIKE CORBYN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("There is only one thing Mike can’t stand when he is shipped off to boarding school at the age of 13. What can he do to cope?")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec22-44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2244#asec22-44"
    }
  }, [_c('b', [_vm._v("Arandobo Balls:")]), _vm._v(" "), _c('i', [_vm._v("Deep-Fried Chicken Adobo–Stuffed Rice Balls")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec23#asec23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MY PLATE IS FULL")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec23-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec23#asec23-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARILYN RANADA DONATO")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Marilyn has it all: a husband, six kids, a career, sports, her own cookbook, and a maid. Her perfect life turns upside down when the maid leaves.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec23-46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2346#asec23-46"
    }
  }, [_c('b', [_vm._v("Meat, Seafood, and Vegetable Paella")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec24#asec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THAT WHICH WE CALL CHAMPORADO")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec24-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec24#asec24-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RAY ESPIRITU")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Ray’s telephone conversation with his mom fizzes with tension until their discussion veers to his favorite childhood dish.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec24-48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2448#asec24-48"
    }
  }, [_c('b', [_vm._v("Champorado:")]), _vm._v(" "), _c('i', [_vm._v("Sweet Chocolate Porridge")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec25#asec25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SUMMER OF ’92")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec25-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec25#asec25-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ADRIAN BRIONES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Summer has just ended, and it is time to go back to school. This dish gets Adrian through his most loathed subject—math.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec25-50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2550#asec25-50"
    }
  }, [_c('b', [_vm._v("Ginataang Bilo-Bilo:")]), _vm._v(" "), _c('i', [_vm._v("Sticky Rice Balls, Sago, and Jackfruit in Coconut Milk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "ch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 7: DESSERTS")])]), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "2",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toca0",
    attrs: {
      "id": "sec26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec26#asec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FINDING SYLVANA")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec26-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec26#asec26-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOUEL OMAMALIN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("“You eat rice for breakfast, lunch, dinner, and dessert,” mocked his colleagues. Chef Pâtissier Nouel proves there is more to Filipino desserts than rice cakes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec26-52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2652#asec26-52"
    }
  }, [_c('b', [_vm._v("Sylvana:")]), _vm._v(" "), _c('i', [_vm._v("Balls of Almond and Candied Lemon Peel Meringue Filled with Coffee Praline Buttercream")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec27#asec27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("THE PEAR-SHAPED AVOCADO")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec27-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec27#asec27-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RODELIO AGLIBOT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("From his Filipino upbringing in Hawaii to the first restaurant he opened in LA, Rodelio shares the story behind one of his signature dishes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec27-54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2754#asec27-54"
    }
  }, [_c('b', [_vm._v("Avocado Mousse with Raspberry Sauce and Lychee Granita")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec28#asec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANATOMY OF A FILIPINO PARTY")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec28-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec28#asec28-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("TIMPLA")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Kristina, Katrina, Aniceto, and Paolo transport a table of 10 strangers in their Washington, DC, row house to family parties from their childhood.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec28-56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2856#asec28-56"
    }
  }, [_c('b', [_vm._v("Cassava Cake with Candied Pecans and Honey-Roasted Apple")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec29#asec29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("UBE: A TASTE OF CHILDHOOD")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec29-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec29#asec29-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MARK CORBYN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Mark’s 13-year-old peers can wrap their heads around spicy honey and ginger or even rhubarb ice cream, but not purple yam ice cream.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec29-58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec2958#asec29-58"
    }
  }, [_c('b', [_vm._v("Ube Halaya Semifreddo:")]), _vm._v(" "), _c('i', [_vm._v("Purple Yam Ice Cream")])])]), _vm._v(" "), _c('p', {
    staticClass: "toca",
    attrs: {
      "id": "sec30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec30#asec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A PERFECT ENDING TO A MEAL")])]), _vm._v(" "), _c('p', {
    staticClass: "toca1",
    attrs: {
      "id": "sec30-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Chapter006sec30#asec30-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("RONI BANDONG")])]), _vm._v(" "), _c('p', {
    staticClass: "tocas"
  }, [_c('i', [_vm._v("Roni and her nanny were a dynamic duo. After her nanny’s death, a vision awakens Roni to what could have been a perfect ending to a meal.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocaa",
    attrs: {
      "id": "sec30-60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Chapter006sec3060#asec30-60"
    }
  }, [_c('b', [_vm._v("Coffee Sans Rival:")]), _vm._v(" "), _c('i', [_vm._v("Meringue, Coffee Buttercream, and Cashew Layer Cake")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ACKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/Index",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("INDEX")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48b6a414","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Contents.vue
// module id = 69
// module chunks = 0